module.exports = __webpack_public_path__ + "public/SiteIcons/moreApprove.svg?1136a8a5";